// extracted by mini-css-extract-plugin
module.exports = {"appInset":"AppInset_appInset__2CLa5","containerFull":"AppInset_containerFull__oKMiT","container":"AppInset_container__ZyQ6G"};